"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _componentsBase = require("@telus-uds/components-base");
var _default = exports.default = _componentsBase.ListBase;